import { render, staticRenderFns } from "./BillingDetailsComponent.vue?vue&type=template&id=3733e61e&scoped=true"
import script from "./BillingDetailsComponent.vue?vue&type=script&lang=ts"
export * from "./BillingDetailsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3733e61e",
  null
  
)

export default component.exports